// extracted by mini-css-extract-plugin
export default {"dropdownBox":"dropdown_dropdownBox__E-5xx","dropdownBoxBorder":"dropdown_dropdownBoxBorder__XsYCD","selected":"dropdown_selected__+pHs5"};